import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { GeneralSnackbarComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/snackbar-ui/components/general-snackbar/general-snackbar.component';
import { OrderSnackbarComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/snackbar-ui/components/order-snackbar/order-snackbar.component';
import { IShopOrderItem } from '@x/ecommerce/shop-client';

export interface GeneralSnackbarData {
  message: string;
  icon?: IconProp;
}

@Injectable()
export class ShopSnackbarService {
  constructor(private _snackBar: MatSnackBar) {}

  general(data: GeneralSnackbarData, config?: MatSnackBarConfig) {
    this._snackBar.openFromComponent(GeneralSnackbarComponent, {
      data,
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      ...config,
    });
  }

  orderItemAdded(orderItem: IShopOrderItem) {
    this._snackBar.openFromComponent(OrderSnackbarComponent, {
      data: { orderItem },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
    });
  }
}
